export default "__VITE_ASSET__XhRDp4tD__"